(function () {
    'use strict';

    angular.module('swif.openbase')
        .controller('OpenbaseSiteEditModalCtrl', OpenbaseSiteEditModalCtrl);

    function OpenbaseSiteEditModalCtrl($scope, $q, $window, swif, openbase, carto, swifOpenbaseCompanyService, goNetEndpointApi) {
        'ngInject';

        console.log('OpenbaseSiteEditModalCtrl');


        swifOpenbaseCompanyService.getGlobalSettings().then(function (company) {
          // Getting global settings to see if company is canadian
            $scope.model.is_canadian = company.is_canadian;
            // Checking where we are in the app to show or not the goNet search (we don't need it if we are in intervention's request)
            $scope.model.showSearchGoNet = (swif.$location.$$path === '/configuration/sites/table_view' && $scope.model.is_canadian);
            if ($scope.model.is_canadian) {
              goNetEndpointApi.getGoNetToken()
              $scope.filters ={
                  canadian_muni: {fields: ['name', 'address', 'codemuni', 'layer_id']}
              }

              $scope.$watch('model.name', function(value){
                // Checking if the site was already created
                if(value && value.length >= 3){
                  let filters = {}
                  swif.data.addFilter(filters, 'name', 'ilike', value)
                  if($scope.model.parcel_matricule){
                    // Only if field is filled
                    swif.data.addFilter(filters, 'parcel_matricule', '=', $scope.model.parcel_matricule)
                  }
                  swif.data.searchRead('site', filters).then(function(site){
                    if(site.ids.length > 0){
                      // show error panel
                      $scope.siteNameAlreadyExists = true;
                      $scope.matchedSiteName = site.ids[0]
                    } else {
                      delete $scope.matchedSiteName;
                      $scope.siteNameAlreadyExists = false;
                    }
                    $scope.form['model.name'].$setValidity(
                      'default',
                      site.ids.length === 0
                    )
                  })
                }
              })
            }
        })


        $scope.modules = swif.module.modules;
        $scope.discountResa = swif.settings.app.features.discountResa;
        $scope.swif = swif;
        if (!swif.module.modules.opengst_carto) {
            return;
        }
        if (!$scope.model.custom_fields) {
            $scope.model.custom_fields = [];
        }
        $scope.getCustomFieldsTemplate = openbase.customfields.getTemplateFromCategory;

        // #3069 temporary boolean for customFields
        $scope.patrimonyCustomFields = swif.settings.app.features.patrimonyCustomFields;

        $scope.showLeaflet = false;
        $scope.onMapInitialized = onMapInitialized;
        if ($scope.model.osm_zoom) {
            $scope.model._osm_zoom = $scope.model.osm_zoom;
        }
        if ($scope.model.osm_type && $scope.model.osm_id) {
            $scope.model._osm_url = `http://www.openstreetmap.org/${$scope.model.osm_type}/${$scope.model.osm_id}`;
        }
        $scope.setGeometryFromOSM = setGeometryFromOSM;
        $scope.fixHiddenLeaflet = function () {
            setTimeout(function () {
                $scope.showLeaflet = true;
                $scope.$apply();
            }, 200);
        };

        $scope.$watch('model._osm_zoom', setZoom);
        $scope.$watch('model._osm_url', setOSMTypeAndId);
        function onMapInitialized (map) {
            $scope.map = map;
            if ($scope.model.osm_zoom) {
                map.setZoom($scope.model.osm_zoom);
            }
            createOrUpdateGeojsonLayer();
        }
        function setZoom (zoom) {
            if (zoom === undefined) {
                $scope.model.osm_zoom = false;
            } else {
                $scope.model.osm_zoom = zoom;
                if ($scope.map) {
                    $scope.map.setZoom(zoom);
                }
            }
        }
        function setOSMTypeAndId (url) {
            //'http://www.openstreetmap.org/way/201328809#map=19/47.19211/-1.69555&layers=D'
            if (url) {
                var splited = url.split('/').slice(3,5);
                if (splited.length === 2) {
                    $scope.model.osm_type = splited[0];
                    $scope.model.osm_id = splited[1].split('#')[0];
                }
            } else {
                $scope.model.osm_type = false;
                $scope.model.osm_id = false;
                $scope.model.geometry = false;
            }
        }
        function setGeometryFromOSM () {
            getOSMGeometry(
                $scope.model.osm_type,
                $scope.model.osm_id
            ).then(function (geometry) {
                $scope.model.geometry = JSON.stringify(geometry);
                createOrUpdateGeojsonLayer();
            });
        }
        function getOSMGeometry (type, id) {
            //download data
            var promise;
            if (type === 'node') {
                promise = carto.osmAPI.getNodeFull(id);
            } else if (type === 'way') {
                promise = carto.osmAPI.getWayFull(id);
            } else if (type === 'relation') {
                promise = carto.osmAPI.getRelationFull(id);
            }
            if (promise) {
                return promise.then(function (data) {
                    return carto.osmtogeojson.togeojson(data);
                }, onOSMError);
            } else {
                return $q.when();
            }
        }
        function createOrUpdateGeojsonLayer() {
            if ($scope.geojsonlayer && $scope.map) {
                if ($scope.map.hasLayer($scope.geojsonlayer)) {
                    $scope.map.removeLayer($scope.geojsonlayer);
                }
                delete $scope.geojsonlayer;
            }
            if ($scope.model.geometry && $scope.map) {
                var features = JSON.parse($scope.model.geometry);
                $scope.geojsonlayer = L.geoJson(features).addTo($scope.map);
            }
        }
        function onOSMError(error) {
            $scope.osmError = error;
        }

        $scope.siteCodeAlreadyExist = false;
        // Checks site_code unicity
        $scope.$watch('model.site_code', function (newRef, oldRef) {
            if (!newRef || newRef == oldRef) {
                return;
            }

            var params = {
                fields: ['id'],
                domain: [
                    ['site_code', '=', newRef]
                ]
            };

            // Exclude current object id
            if ($scope.model._type == 'site' && $scope.model.id) {
                params.domain.push(['id', '!=', $scope.model.id]);
            }

            // Checks for matched site according to site_code
            // Display panel-site component if found
            swif.data.searchRead('site', params).then(function (matchedSite_codes) {
                if (matchedSite_codes.ids.length > 0) {
                    $scope.siteCodeAlreadyExist = true;
                    $scope.matchedSite = matchedSite_codes.ids[0]
                } else {
                    delete $scope.matchedSite;
                    $scope.siteCodeAlreadyExist = false;
                }

                $scope.form['model.site_code'].$setValidity(
                    'default',                          // default don't exist: just highlight the field in red without any message
                    matchedSite_codes.ids.length === 0  // if there is no matched site found
                );
            });
        });

    }
})();
